<template>
  <div class="login_container">
    <div class="logo">
      <img src="@/assets/images/logo/logo_login.png" alt="极目新闻" />
    </div>
    <div class="login_form">
      <van-form>
        <van-field v-model="loginInfo.mobilePhone" name="手机号" placeholder="请输入手机号" :rules="[{ required: true, message: '' }]" class="phone_box">
          <Icon iconClass="phone" slot="left-icon" />
        </van-field>
        <van-field v-model="loginInfo.authCode" name="验证码" placeholder="请输入验证码" :rules="[{ required: true, message: '' }]" class="code_box">
          <Icon iconClass="mail" slot="left-icon" />
          <template #button>
            <button class="send_code" ref="timeLocation" @click="sendCode($event)">
              发送验证码
            </button>
          </template>
        </van-field>
        <van-checkbox v-model="checked" checked-color="#ca2d2c" icon-size="16px" class="agree_box">我同意接受极目新闻注册协议</van-checkbox>
        <van-button round native-type="submit" size="small" block color="#ca2d2c" @click="onLogin" class="login_btn">登 录</van-button>
      </van-form>
    </div>
    <div class="login_tips">
      登陆即代表您已阅读并同意<span @click="toProtocol">用户协议</span>和<span @click="toPrivate">隐私政策</span>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { testMobilePhone, wxUserInfoAuthorize, getUrlParamByKey } from "@/utils";
import loginApi from "@/api/apis/login.js";
import { Toast } from 'vant';
var fromPath = { path: "/", query: {} };
export default {
  name: "Login",
  data() {
    return {
      memberId: null,
      loginInfo: {
        mobilePhone: "",
        authCode: "",
      },
      timePicker: null,
      checked: false,
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode", "wxAppId","authType","clientId","clientSecret"]),
  },
  methods: {
    ...mapActions("app", ["setToken", "setUserInfo"]),
    /* 发送验证码 */
    sendCode(e) {
      var _this = this;
      if (testMobilePhone(_this.loginInfo.mobilePhone)) {
        var time = 59;
        if (_this.$refs.timeLocation) {
          _this.$refs.timeLocation.innerHTML = "请(" + time + ")秒后重新获取";
          _this.$refs.timeLocation.disabled = true;
        }
        _this.timePicker = setInterval(function () {
          time--;
          if (time == 0) {
            clearInterval(_this.timePicker);
            if (_this.$refs.timeLocation) {
              _this.$refs.timeLocation.innerHTML = "发送验证码";
              _this.$refs.timeLocation.disabled = false;
            }
          } else {
            if (_this.$refs.timeLocation) {
              _this.$refs.timeLocation.innerHTML =
                "请(" + time + ")秒后重新获取";
            }
          }
        }, 1000);

        var params = {
          mobilephone: _this.loginInfo.mobilePhone,
          nodeCode: _this.nodeCode,
        };
        loginApi
          .getAuthCode(params)
          .then((res) => {
            if (res.suc == 1) {
              _this.$toast({
                message: "发送成功",
                position: "center",
              });
            } else {
              _this.$toast({
                message: "发送验证码失败,请稍后再试!",
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        _this.$toast({
          message: "请输入正确的手机号",
          position: "center",
        });
      }
    },
    /* 手机验证码登录 */
    onLogin() {
      var _this = this;
      if (testMobilePhone(_this.loginInfo.mobilePhone)) {
        if (!_this.loginInfo.authCode || _this.loginInfo.authCode.length != 6) {
          return _this.$toast({
            message: "请输入正确的验证码",
            position: "center",
          });
        }

        if (!_this.checked) {
          return _this.$toast({
            message: "请同意接受极目新闻注册协议",
            position: "center",
          });
        }

        var params = {
          authType: _this.authType,
          clientId: _this.clientId,
          clientSecret: _this.clientSecret,
          phoneCode: _this.loginInfo.authCode,
          phoneNumber: _this.loginInfo.mobilePhone,
          scope: "",
        };
        var p = JSON.stringify(params);
        loginApi
          .loginByPhone(p)
          .then((res) => {
            if (res.suc == 1) {
              _this.setToken(res.data);
              _this.getUserInfo(); //登录之后获取用户信息
            } else {
              _this.$toast({
                message: res.message,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        _this.$toast({
          message: "请输入正确的手机号",
          position: "center",
        });
      }
    },
    /* 获取用户信息 */
    getUserInfo() {
      var _this = this;
      loginApi
        .getMemberByToken()
        .then((res) => {
          if (res.suc == 1) {
            clearInterval(_this.timePicker);
            let userInfo = res.data.memberInfo;
            _this.setUserInfo(userInfo);
            // _this.goBackOrHome();
            _this.$router.back(-1);
          } else {
            _this.$toast({
              message: "登录失败，请稍后再试！",
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 直接返回原页面或者跳转首页 */
    goBackOrHome() {
      this.$router.replace({
        path: fromPath.path,
        query: fromPath.query,
      });
    },
    /* 跳转用户协议 */
    toProtocol() {
      this.$router.push("/protocol");
    },
    /* 跳转隐私协议 */
    toPrivate() {
      this.$router.push("/private");
    },
    /* 判断是否页面来自图文稿新闻详情页 */
    isFromNewsDetail(){
      let me=this;
      let hasSession=window.sessionStorage.getItem('routerInfo');
      if(/news_detail/.test(fromPath.path) || hasSession){
        return true;
      }
      else{
        return false;
      }
    },
  },
  /* 进入路由之前执行的函数,写在组件里可根据路由进行页面判断或传值 */
  beforeRouteEnter(to, from, next) {
    console.log("from:", from);
    fromPath.path = from.fullPath;
    fromPath.query = from.query;
    next();
  },
  mounted() {
    var _this = this;
    _this.memberId = !!_this.userInfo ? _this.userInfo.id : null;

    var token = window.localStorage.getItem("accessToken");
    let tokenTime = window.localStorage.getItem("tokenTime");
    var expiresIn = window.localStorage.getItem("expiresIn");

    let time = new Date().getTime();
    // wxUserInfoAuthorize(window.location.href, _this.wxAppId, "login");
    /* 已登录，而且token没有过期，直接返回原页面或者跳转首页 */
    console.log('token==',token)
    console.log('_this.memberId==',_this.memberId)
    if (!!token && !!_this.memberId && (time - parseInt(tokenTime) <= (parseInt(expiresIn) - 5) * 1000)){
      // _this.goBackOrHome();
      _this.$router.back(-1);
    } else {
      /* 微信授权登录，首先要判断是否是在微信浏览器中 */
      var ua = navigator.userAgent.toLowerCase();
      if (/MicroMessenger/gi.test(ua)) {
        /* 判断是否是微信授权后重定向回来 */

        var urlParams = new URLSearchParams(window.location.search);
        var code = urlParams.get('code') || getUrlParamByKey("code");
        var state = urlParams.get('state') || getUrlParamByKey("state");

        // var code = getUrlParamByKey("code");
        // var state = getUrlParamByKey("state");
        console.log('code==',code)
        console.log('state==',state)
        if ("login" == state && code && code.length > 0) {
          let loading = Toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
          });
          var params = { code: code, nodeCode: _this.nodeCode };
          loginApi
            .getWeixinMemberInfo(params)
            .then((res) => {
              loading.clear();
              if (res.suc == 1) {
                let userInfo = res.data.memberInfo;
                _this.setUserInfo(userInfo);
                // _this.goBackOrHome();
                // _this.$router.back(-2);
                if(_this.isFromNewsDetail()){
                  let routePath=window.sessionStorage.getItem('routerInfo');
                  this.$router.replace(routePath);
                }
                else{
                  _this.$router.back(-1);
                }
              } else {
                _this.$toast({
                  message: "登录失败，请重试！",
                  position: "center",
                });
              }
            })
            .catch((err) => {
              loading.clear();
              _this.$toast({
                message: "登录失败，请重试！",
                position: "center",
              });
            });
        } else {
          console.log('window.location.href:',window.location.href);
          wxUserInfoAuthorize(window.location.href, _this.wxAppId, "login");
        }
      } else if(navigator.userAgent.match(/QQ\/([\d\.]+)/)) {

        var urlParams = new URLSearchParams(window.location.search);
        var suc = urlParams.get('suc') || getUrlParamByKey("suc");
        var tempToken = urlParams.get('tempToken') || getUrlParamByKey("tempToken");

        if(suc == 1 && tempToken){
          let loading = Toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
          });
          loginApi
            .getLoginData({ tempToken: tempToken })
            .then((res) => {
              if (res.suc == 1) {
                _this.setToken(res.data);
                console.log('开始获取信息-------------')
                loginApi
                .getMemberByToken()
                .then((res) => {
                  if (res.suc == 1) {
                    let userInfo = res.data.memberInfo;
                    _this.setUserInfo(userInfo);
                    loading.clear();
                    if(_this.isFromNewsDetail()){
                      let routePath=window.sessionStorage.getItem('routerInfo');
                      this.$router.replace(routePath);
                    }
                    else{
                      _this.$router.back(-1);
                    }
                  } else {
                    loading.clear();
                    _this.$toast({
                      message: "登录失败，请稍后再试！",
                      position: "center",
                    });
                  }
                })
                .catch((err) => {
                  loading.clear();
                  _this.$toast({
                    message: "接口调用出错",
                    position: "center",
                  });
                });
               
              } else {
                loading.clear();
                _this.$toast({
                  message: "登录失败，请重试！",
                  position: "center",
                });
              }
            })
            .catch((err) => {
              loading.clear();
              _this.$toast({
                message: "登录失败，请重试！",
                position: "center",
              });
            });
        }else{
          window.location.href = 'https://yth.ctdsb.net/amc/qqThirdLogin/qqLogin?redirectUrl='+encodeURIComponent(window.location.href);
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.login_container {
  position: relative;
  max-width: 750px;
  min-height: 100vh;
  width: 100%;
  margin: auto;
  overflow: hidden;
  .logo {
    width: 36%;
    margin: 33% auto 30px;
    img {
      width: 100%;
    }
  }
  .login_form {
    width: 62.5%;
    margin: 0 auto;
    .van-form {
      .tj-svg-icon {
        color: #bdbdbd;
        font-size: 18px;
      }
      .van-cell {
        padding: 15px 5px 5px;
        border-top: none;
        border-bottom: 1px solid #e8e8e8;
        &::after {
          display: none;
        }
        &.phone_box {
          /deep/.van-field__left-icon {
            margin-right: 0;
            .phone {
              position: relative;
              left: -2px;
              font-size: 20px;
            }
          }
        }
        &.code_box {
          padding-right: 0;
          .send_code {
            height: 20px;
            padding-left: 0;
            padding-right: 0;
            line-height: 20px;
            border: none;
            background-color: transparent;
            color: #ca2d2c;
            font-size: 12px;
            &:disabled {
              padding-left: 4px;
              padding-right: 4px;
              background-color: #ececec;
              color: #8f8f8f;
              border-radius: 8px;
            }
          }
        }
      }
      .agree_box {
        padding: 10px 5px;
        font-family: "STSong";
        font-size: 12px;
        /deep/.van-checkbox__label {
          color: #b7adad;
          font-family: "STSong";
          font-size: 12px;
        }
      }
      .login_btn {
        margin-top: 20px;
        font-family: "STSong";
        font-size: 16px;
      }
    }
  }
  .login_tips {
    margin: 30% auto 0;
    text-align: center;
    color: #c4c4c4;
    font-size: 12px;
    white-space: nowrap;
    span {
      margin-left: 5px;
      margin-right: 5px;
      text-decoration: underline;
    }
  }
}
</style>